let url = {}

switch (process.env.VUE_APP_MODE) {
  // 本地mock环境 共用开发环境
  case 'mock':
    break
  // 本地开发环境
  case 'development':
    url = {
      npxsxemluckydex: 'http://192.168.20.234:8887/'
    }
    break
  // 线上开发环境
  case 'dev':
    url = {
      npxsxemluckydex: 'https://xxx/'
    }
    break
  // uat环境
  case 'uat':
    url = {
      npxsxemluckydex: 'https://activity-p1-uat.pundix.com/npxsxemapi/'
    }
    break
    // order环境
  case 'order':
    url = {
      npxsxemluckydex: `${window.location.protocol}//${window.location.hostname}/npxsxemapi/`
    }
    break
  // 生产环境
  case 'prod':
    url = {
      npxsxemluckydex: 'https://activity-p1-uat.pundix.com/npxsxemapi/'
    }
    break
  // 默认 同 本地开发环境
  default:
    url = {
      npxsxemluckydex: 'https://xxx/'
    }
}

export default url
